export default "__VITE_ASSET__BWwNdC36__"